import React from 'react';
import { ResponsivePie } from '@nivo/pie';
import { ResponsiveRadialBar } from '@nivo/radial-bar';
import Notification from '../Common/Notification';
import StatusLegend from '../Common/StatusLegend/StatusLegend';
import './Charts.scss';
import { GRAPH_STATUSES } from '../../constants/constants';

export default class Charts extends React.Component {

  constructor() {
    super();
    this.state = {
    };
  }

  onMilestonesGraphClick = (e) => {
    Notification("success", "Milestones", `Status: ${e.id}`);
  }

  onTasksGraphClick = (e) => {
    Notification("success", "Tasks", `Status: ${e.id}`);
  }

  onRadialGraphClick = (e) => {
    Notification("success", "Tasks", `Status: ${e.id}`);
  }

  getColor = (bar) => {
    const colors = { 'Complete': '#40AF32', 'Past Due': '#D20005', 'In Progress': '#82b1ff', 'Not Due': 'CDCCCC' };
    return colors[bar.id]
  };

  render() {

    return (
      <div className="guide-page">
        <h3 className="guide-title">Charts Research</h3>
        <p className="guide-lead">Researching an implementation of charts for dashboards via the <a href="https://nivo.rocks" rel="noopener noreferrer" target="_blank">Nivo</a> chart library</p>

        <div className="arc-section">
          <h4>Arc Graph</h4>

          <StatusLegend />

          <div className="arc-example" style={{ height: '200px', width: '200px' }}>
            <ResponsivePie
              data={[
                {
                  "id": "Not applicable",
                  "label": "Not applicable",
                  "value": 20,
                  "color": "#ACE874"
                },
                {
                  "id": "Complete",
                  "label": "Complete",
                  "value": 12,
                  "color": "#40AF32"
                },
                {
                  "id": "Past Due",
                  "label": "Past Due",
                  "value": 9,
                  "color": "#D20005"
                },
                {
                  "id": "In Progress",
                  "label": "In Progress",
                  "value": 6,
                  "color": "#82b1ff"
                },
                {
                  "id": "Not Due",
                  "label": "Not Due",
                  "value": 2,
                  "color": "#CDCCCC"
                }
              ]}
              startAngle={-90}
              endAngle={90}
              innerRadius={0.75}
              padAngle={3}
              colorBy={function (e) { return e.color }}
              enableRadialLabels={false}
              slicesLabelsTextColor="#000000"
              animate={false}
              isInteractive={false}
              onClick={this.onTasksGraphClick} />
            <span className="arc-total">49</span>
            <span className="arc-total-label">Total Tasks</span>
          </div>

          <div className="arc-example" style={{ height: '200px', width: '200px' }}>
            <ResponsivePie
              data={[
                {
                  "id": "Not applicable",
                  "label": "Not applicable",
                  "value": 5,
                  "color": "#ACE874"
                },
                {
                  "id": "Complete",
                  "label": "Complete",
                  "value": 4,
                  "color": "#40AF32"
                },
                {
                  "id": "Past Due",
                  "label": "Past Due",
                  "value": 4,
                  "color": "#D20005"
                },
                {
                  "id": "In Progress",
                  "label": "In Progress",
                  "value": 2,
                  "color": "#82b1ff"
                },
                {
                  "id": "Not Due",
                  "label": "Not Due",
                  "value": 1,
                  "color": "#CDCCCC"
                }
              ]}
              startAngle={-90}
              endAngle={90}
              innerRadius={0.75}
              padAngle={3}
              colorBy={function (e) { return e.color }}
              enableRadialLabels={false}
              slicesLabelsTextColor="#000000"
              animate={false}
              isInteractive={false}
              onClick={this.onMilestonesGraphClick} />
            <span className="arc-total">16</span>
            <span className="arc-total-label">Milestone Tasks</span>
          </div>

        </div>

        <div className="donut-section">
          <h4>Donut Graph</h4>
        </div>

        <div className="line-section">
          <h4>Line Graph</h4>
        </div>

        <div className="bar-section">
          <h4>Bar Graph</h4>
        </div>

        <div className="horizontal-stacked-bar-section">
          <h4>Horizontal Stacked Bar</h4>
        </div>

        <div style={{ height: '400px', width: '400px' }}>
          <h4>RadialBar Graph</h4>
          <StatusLegend />
          <ResponsiveRadialBar
            data={[
              {
                "id": "Tasks",
                "data": [
                  {
                    "x": "Not applicable",
                    "y": 43
                  },
                  {
                    "x": "Complete",
                    "y": 144
                  },
                  {
                    "x": "Past Due",
                    "y": 52
                  },
                  {
                    "x": "In Progress",
                    "y": 196
                  },
                  {
                    "x": "Not Due",
                    "y": 132
                  }
                ]
              },
              {
                "id": "Milestones",
                "data": [
                  {
                    "x": "Not applicable",
                    "y": 21
                  },
                  {
                    "x": "Complete",
                    "y": 149
                  },
                  {
                    "x": "Past Due",
                    "y": 77
                  },
                  {
                    "x": "In Progress",
                    "y": 115
                  },
                  {
                    "x": "Not Due",
                    "y": 140
                  }
                ]
              },
              {
                "id": "Project Implemented",
                "data": [
                  {
                    "x": "Not applicable",
                    "y": 14
                  },
                  {
                    "x": "Complete",
                    "y": 286
                  },
                  {
                    "x": "Past Due",
                    "y": 269
                  },
                  {
                    "x": "In Progress",
                    "y": 51
                  },
                  {
                    "x": "Not Due",
                    "y": 212
                  }
                ]
              }
            ]}
            colors={[
              GRAPH_STATUSES.NotApplicable.color,
              GRAPH_STATUSES.Complete.color,
              GRAPH_STATUSES.PastDue.color,
              GRAPH_STATUSES.InProgress.color,
              GRAPH_STATUSES.NotDue.color
            ]}
            onClick={this.onRadialGraphClick}
            valueFormat=">-.2f"
            padding={0.4}
            cornerRadius={2}
            margin={{ top: 40, right: 120, bottom: 40, left: 40 }}
            radialAxisStart={{ tickSize: 5, tickPadding: 5, tickRotation: 0 }}
            circularAxisOuter={{ tickSize: 5, tickPadding: 12, tickRotation: 0 }}
          />
        </div>
      </div>
    );
  }
}

